import styled from 'styled-components';
import MultiSelectProps from './type';
import checkIcon from '../Icon/icons/special/check.svg';

export const MultiSelectWrapperStyled = styled.div<MultiSelectProps>`
  width: ${({ fullWidth, width }) => {
    if (width) {
      return width;
    }
    if (fullWidth) {
      return '100%';
    }
    return 'min-content';
  }};
  position: relative;
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
`;

export const MultiSelectButtonStyled = styled.button<MultiSelectProps>`
  ${({ theme }) => theme.typography.bodyMedium3};
  padding-inline: 20px;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  background: #e3edf7;
  border-radius: 4px;
  cursor: pointer;
  ${({ open }) =>
    open
      ? ''
      : `
        transition-duration: 0.25s;
        transition-delay: 0.5s;
        `};
  border: 1px solid #fff;
  box-shadow: ${({ open }) =>
    open
      ? '4px 4px 14px 0px #D9D9D9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;'
      : '4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff, 2px 2px 4px 0px rgba(114, 142, 171, 0.1);'};
  p {
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right: 20px;
    color: ${({ open }) => (open ? '#0057B8' : '#5B5D71')};
  }
`;

export const MultiSelectItemWrapperStyled = styled.div<MultiSelectProps>`
  overflow: scroll;
  width: min-content;
  transform-origin: top;
  ${({ open }) =>
    open ? 'transform: scaleY(1);  max-height: 570px;' : 'transform: scaleY(0);  max-height: 0px;'}
  transition-duration: 0.5s;
  button:nth-last-child(-n + 1) {
    border-radius: 0px 0px 4px 4px;
  }
  position: absolute;
  top: calc(100% + 20px);
  z-index: 100;
  border-radius: 4px;
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff,
    2px 2px 4px 0px rgba(114, 142, 171, 0.1);
`;

export const MultiSelectBodyItemWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0px;
  border-radius: 4px;
  background: #fff;
  gap: 14px;
`;

export const MultiSelectItemStyled = styled.button<MultiSelectProps>`
  ${({ theme }) => theme.typography.body3};
  display: flex;
  align-items: center;
  gap: 7px;
  height: min-content;
  color: ${({ theme }) => theme.colors.gray700};
  text-align: start;
  padding-inline: 20px;
  background: #fff;
  border: 1px solid #fff;
  border-top: 0px;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  p {
    text-overflow: ellipsis;
    overflow: hidden;
    margin: 10px 0px;
  }
`;

export const RadioButtonWrapper = styled.div<{ checked: boolean }>`
  border-radius: 50%;
  padding: 1px;
  background: ${({ checked }) =>
    checked
      ? 'linear-gradient(rgba(255,255,255,1), rgba(255,255,255,0))'
      : 'linear-gradient(90deg, rgba(214, 227, 243, 0.9), rgba(255, 255, 255, 0.9))'};
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff;
`;

export const RadioButton = styled.div<{ checked: boolean }>`
  border-radius: 50%;
  background: ${({ checked }) =>
    checked ? 'linear-gradient(90deg, #0057B8, #6CC7DC)' : '#e3edf7'};
  position: relative;
  height: 16px;
  width: 16px;
  overflow: visible;

  ::before {
    content: '';
    visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};
    position: absolute;
    height: 60%;
    width: 60%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url(${checkIcon});
    background-size: auto;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const IconWrapperMultiSelectAnimation = styled.div<MultiSelectProps>`
  ${({ open }) =>
    open
      ? { transform: 'rotate(180deg)', transitionDuration: '0.5s' }
      : { transform: 'rotate(360deg)', transitionDuration: '0.5s' }}
`;

export const HandlersMultiSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-inline: 20px;
  margin-top: 10px;
`;
